import { styled } from "@mui/material/styles";

export const StyledLoading = styled('div')(({ theme }) => ({
    top: '50%',
    left: '50%',
    position: 'relative',
}))